module.exports = __webpack_public_path__ + "img/newLogo.bb7fb1f2.png";